<template>
    <div id="all_page" class="account-page">
        <div>
            <div>
                <div id="account_main">
                    <template v-if="is_owner == 0 && is_admin == 0">
                        <div id="main_slider_div">
                            <div class="d-flex">
                                <div class="flex-item item_2 slider_link_left">
                                    <p id="my_medmobil" class="gray base_22" style="text-align: left">
                                        <a
                                            v-on:click="slider_click('my_medmobil', 0, 2)"
                                            class="in none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Мой Medmobil</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_right">
                                    <p id="settings" class="gray base_22" style="text-align: right">
                                        <a
                                            v-on:click="slider_click('settings', 1, 2)"
                                            class="out none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Настройки</a
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div id="st_p" style="margin-top: 20px; width: 100%">
                                    <div id="st_l" style="margin-left: 0px" class="slider"></div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else-if="is_admin">
                        <div style="width: max-content" id="main_slider_div">
                            <div class="d-flex" style="height: 50px; width: 100%">
                                <div class="flex-item item_2 slider_link_left">
                                    <p id="searchData" class="gray base_22" style="text-align: left">
                                        <a
                                            v-on:click="slider_click('searchData', 1, 4)"
                                            class="out none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Поиск</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_mid">
                                    <p id="orders" class="gray base_22" style="text-align: center">
                                        <a
                                            v-on:click="slider_click('orders', 2, 4)"
                                            class="in none_style"
                                            style="display: flex; color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Заказы</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_mid">
                                    <p id="applications" class="gray base_22" style="display: flex; text-align: center">
                                        <a
                                            v-on:click="slider_click('applications', 3, 4)"
                                            class="mid none_style"
                                            style="display: flex; color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Заявки</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_mid">
                                    <p id="console" class="gray base_22" style="display: flex; text-align: center">
                                        <a
                                            v-on:click="slider_click('console', 4, 4)"
                                            class="mid none_style"
                                            style="display: flex; color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Консоль</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_right">
                                    <p id="settings" class="gray base_22" style="text-align: right">
                                        <a
                                            v-on:click="slider_click('settings', 5, 4)"
                                            class="out none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Настройки</a
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div id="st_p" style="margin-top: 20px; width: 100%">
                                    <div id="st_l" style="margin-left: 0px" class="slider"></div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div style="width: max-content" id="main_slider_div">
                            <div class="d-flex" style="height: 50px; max-width: 100%">
                                <div class="flex-item item_2 slider_link_left">
                                    <p id="my_medmobil" class="gray base_22" style="text-align: left">
                                        <a
                                            v-on:click="slider_click('my_medmobil', 0, 3)"
                                            class="in none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Мой Medmobil</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_mid">
                                    <p id="grant_dispatcher" class="gray base_22" style="text-align: center">
                                        <a
                                            v-on:click="slider_click('grant_dispatcher', 1, 3)"
                                            class="mid none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Делегирование полномочий</a
                                        >
                                    </p>
                                </div>
                                <div class="flex-item item_2 slider_link_right">
                                    <p id="settings" class="gray base_22" style="text-align: right">
                                        <a
                                            v-on:click="slider_click('settings', 2, 3)"
                                            class="out none_style"
                                            style="color: #6e7675; font-size: 20px; cursor: pointer"
                                            >Настройки</a
                                        >
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div id="st_p" style="margin-top: 20px; width: 100%">
                                    <div id="st_l" style="margin-left: 0px" class="slider"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <br /><br />

                <div id="my_medmobil_page"  class="account_page">
                    <div class="d-flex">
                        <div class="flex-item item_8">
                            <div v-if="role_value == 'User'">
                                <p style="text-align: left; line-height: 1.5; color: gray">
                                    Вы успешно прошли регистрацию в сервисе Medmobil.<br /><br />
                                    На указанный Вами адрес: <i>{{ email }}</i> отправлено письмо о регистрации в
                                    сервисе.<br />
                                    Подтвердите, пожалуйста, Ваш адрес по ссылке из письма, после чего Вы сможете
                                    пользоваться нашим сервисом в полной мере.
                                </p>
                            </div>
                            <div v-else>
                                <div v-if="role_value == 'ConfirmedUser'">
                                    <p
                                        class="base_18 gray"
                                        style="text-align: left; padding-left: 1vw; padding-top: 0vw"
                                    >
                                        <a href="/order" class="plain_text_link">Заказать поездку</a>
                                    </p>
                                    <p
                                        class="base_18 gray"
                                        style="text-align: left; padding-left: 1vw; padding-top: 0vw"
                                    >
                                        <a href="/my_orders" class="plain_text_link">Мои заказы</a>
                                    </p>
                                </div>
                                <div v-else>
                                    <div v-if="role_value == 'Dispatcher'">
                                        <p
                                            class="base_18 gray"
                                            style="text-align: left; padding-left: 1vw; padding-top: 0vw"
                                        >
                                            <a href="/new_orders" class="plain_text_link">Новые заказы</a>
                                        </p>
                                        <p
                                            class="base_18 gray"
                                            style="text-align: left; padding-left: 1vw; padding-top: 0vw"
                                        >
                                            <a href="/order_history" class="plain_text_link">История заказов</a>
                                        </p>
                                        <p
                                            class="base_18 gray"
                                            style="text-align: left; padding-left: 1vw; padding-top: 0vw"
                                        >
                                            <a href="/manual_dispatcher.pdf" target="_blank" class="plain_text_link"
                                                >Инструкция по работе</a
                                            >
                                        </p>
                                    </div>
                                    <div v-else>
                                        <div v-if="role_value == 'Owner'">
                                            <div style="text-align: left; padding-left: 15px">
                                                <p class="base_18 gray" style="padding-top: 0vw">
                                                    Вам доступен полный функционал владельца услуги перевозки.<br />
                                                    По мере развития проекта Ваш функционал будет расширяться.
                                                </p>
                                                <div class="marginPaddingForm" style="margin-top: 60px"></div>
                                                <b class="formlabel">Выбор региона</b>
                                                <div id="region_owner" style="margin-top: 30px">
                                                    <regionMenu
                                                        :key="default_region"
                                                        :getApi="false"
                                                        :defaultRegion="default_region"
                                                    ></regionMenu>
                                                </div>
                                                <input
                                                    id="save_region_owner"
                                                    type="submit"
                                                    value="Сохранить регион"
                                                    style="width: 376px; height: 66px; margin-top: 40px"
                                                    v-on:click="saveRegionCarrier()"
                                                />
                                            </div>
                                        </div>
                                        <div v-else></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- thit is new page \|/ -->
                <div id="grant_dispatcher_page"  class="account_page">
                    <form id="form_new_dispatcher">
                        <div id="is_owner">
                            <div class="d-flex">
                                <CInput
                                    v-model="dispatcherEmail"
                                    :validationFunction="tools.validateEmail"
                                    className="forminput"
                                    ref="input_email"
                                    id="email"
                                    name="email"
                                    label="Email"
                                    placeholder="primer@medmobil.ru"
                                    required
                                />
                                <CInput
                                    v-model="dispatcherPhone"
                                    :validationFunction="tools.validatePhone"
                                    :mask="tools.formatPhone"
                                    className="forminput"
                                    ref="input_phone"
                                    id="phone"
                                    name="phone"
                                    label="Телефон"
                                    placeholder="+7 (___) ___-__-__"
                                    required
                                />
                            </div>
                            <div class="d-flex" style="text-align: left">
                                <div
                                    class="flex-item item_1"
                                    style="text-align: left; padding: 15px; padding-left: 0px"
                                >
                                    <input
                                        id="set_dispatcher"
                                        type="submit"
                                        value="Добавить пользователя как диспетчера"
                                        style="
                                            width: 540px;
                                            height: 66px;
                                            margin-top: 40px;
                                            padding-left: 0px;
                                            padding-right: 0px;
                                        "
                                    />
                                </div>
                                <div
                                    class="flex-item item_1"
                                    style="text-align: right; padding: 15px; padding-right: 0px"
                                >
                                    <input
                                        id="remove_dispatcher"
                                        type="submit"
                                        value="Забрать права диспетчера"
                                        style="
                                            width: 496px;
                                            height: 66px;
                                            margin-top: 40px;
                                            padding-left: 0px;
                                            padding-right: 0px;
                                            background: #fa777e;
                                        "
                                    />
                                </div>
                            </div>
                            <table align="center">
                                <tr>
                                    <td>
                                        <div><p style="color: red" id="add_dispatcher"></p></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </form>
                </div>

                <div id="console_page"  class="account_page">
                    <div class="d-flex">
                        <textarea
                            style="
                                background: black;
                                color: green;
                                width: 100%;
                                min-height: 42vw;
                                word-break: break-all;
                                margin-bottom: 1vw;
                            "
                            spellcheck="false"
                            id="console_terminal"
                        ></textarea>
                    </div>
                </div>

                <div id="searchData_page"  class="account_page">
                    <p id="searchData_header" class="boldlabel" style="font-size: 26px">
                        {{ SearchInputTable.SearchTypeName }}
                    </p>
                    <span class="searchData_type">
                        <label class="checkbox" v-on:click="getSearchResponse('orders')">
                            <div class="check__container">
                                <input
                                    type="radio"
                                    id="search_orders"
                                    name="search_type"
                                    value="Поиск по заказам"
                                    v-model="SearchInputTable.SearchTypeName"
                                    checked
                                />
                                <span class="checkmark"></span>
                            </div>
                            <a class="checkmark_text">Заказы</a>
                        </label>
                        <label class="checkbox" v-on:click="getSearchResponse('users')">
                            <div class="check__container">
                                <input
                                    type="radio"
                                    id="search_users"
                                    name="search_type"
                                    value="Поиск по пользователям"
                                    v-model="SearchInputTable.SearchTypeName"
                                />
                                <span class="checkmark"></span>
                            </div>
                            <a class="checkmark_text">Пользователи</a>
                        </label>
                        <label class="checkbox" v-on:click="getSearchResponse('carriers')">
                            <div class="check__container">
                                <input
                                    type="radio"
                                    id="search_carriers"
                                    name="search_type"
                                    value="Поиск по перевозчикам"
                                    v-model="SearchInputTable.SearchTypeName"
                                />
                                <span class="checkmark"></span>
                            </div>
                            <a class="checkmark_text">Перевозчики</a>
                        </label>
                    </span>
                    <hr style="margin: 0 auto; margin-top: 25px" align="center" width="95%" size="2" color="#e9ecec" />
                    <label class="container_searchFilter">
                        <input
                            v-model="SearchInputTable.searchQuery"
                            type=""
                            id="search_users_input"
                            name="search_users_input"
                            placeholder="Поиск"
                            style="width: 90%; margin-top: 30px; height: 3.96vw"
                            class="forminput"
                        />
                        <div class="container_filter">
                            <span
                                class="filter_item_box"
                                v-for="(filterLabel, filterValue) in SearchInputTable.filters[
                                    SearchInputTable.SearchInputType
                                ]"
                                :key="filterValue"
                            >
                                <input
                                    class="filter_item_checkbox"
                                    type="radio"
                                    :id="'search_filter_' + filterValue"
                                    v-model="SearchInputTable.selectedFilter"
                                    name="filter_item"
                                    :value="filterValue"
                                />
                                <label class="filter_item" :for="'search_filter_' + filterValue">{{
                                    filterLabel
                                }}</label>
                            </span>
                        </div>
                    </label>
                    <hr style="margin: 0 auto; margin-top: 25px" align="center" width="95%" size="2" color="#e9ecec" />
                    <div class="container_searchList">
                        <label v-for="(item, index) in filteredData" :key="index" class="searchList_case">
                            <div class="case_searchList" v-for="(value, index) in item" :key="index">
                                <span class="case_index">{{ index }}</span>
                                <p class="case_value">{{ value }}</p>
                            </div>
                        </label>
                    </div>
                </div>

                <div id="orders_page"  class="account_page">
                    <div style="display: flex">
                        <span id="superviser__control" class="superviser__control" v-on:click="reRender()">
                            <label id="filter__head" class="filter__head">
                                <img
                                    v-on:click="flexFilters()"
                                    src="../assets/IMGS/SVG/filterIco.svg"
                                    alt="filter"
                                    style="cursor: pointer"
                                />
                                <a
                                    id="filter_zone_item"
                                    v-on:click="reFiltering()"
                                    style="cursor: pointer; color: #ff8a90; border-bottom: 2.9px dotted #ff8a90"
                                    >Очистить</a
                                >
                            </label>
                            <label id="filter_org" style="" class="fliter__status">
                                <a class="head__text">Компания</a>
                                <input
                                    id="organisation_name"
                                    list="organisation_name_datalist"
                                    style="width: 230px; padding: 0px"
                                />
                            </label>
                            <label id="filter_status" class="fliter__status">
                                <a class="head__text">Статус заказа</a>
                                <div id="order_status_select_box" class="select-box custom-select">
                                    <div class="myarrow"></div>
                                    <div
                                        id="order_status_selected"
                                        class="selected_option"
                                        v-on:click.stop="tools.selectedOpenClose('order_status')"
                                    >
                                        <p id="order_status" class="selected_text">Любой</p>
                                        <p id="order_status_index" class="selected_hidden_index">-1</p>
                                    </div>
                                    <div id="order_status_options" class="options">
                                        <div
                                            id="order_status_option1"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 1, 11)"
                                        >
                                            <p id="order_status_option1_text" class="option_text">Любой</p>
                                        </div>
                                        <div
                                            id="order_status_option2"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 2, 11)"
                                        >
                                            <p id="order_status_option2_text" class="option_text">Подтвержден</p>
                                        </div>
                                        <div
                                            id="order_status_option3"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 3, 11)"
                                        >
                                            <p id="order_status_option3_text" class="option_text">Запланирован</p>
                                        </div>
                                        <div
                                            id="order_status_option4"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 4, 11)"
                                        >
                                            <p id="order_status_option4_text" class="option_text">Выезд</p>
                                        </div>
                                        <div
                                            id="order_status_option5"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 5, 11)"
                                        >
                                            <p id="order_status_option5_text" class="option_text">Выполняется</p>
                                        </div>
                                        <div
                                            id="order_status_option6"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 6, 11)"
                                        >
                                            <p id="order_status_option6_text" class="option_text">Выполнен</p>
                                        </div>
                                        <div
                                            id="order_status_option7"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 7, 11)"
                                        >
                                            <p id="order_status_option7_text" class="option_text">Отмена</p>
                                        </div>
                                        <div
                                            id="order_status_option8"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 8, 11)"
                                        >
                                            <p id="order_status_option8_text" class="option_text">Отказ</p>
                                        </div>
                                        <div
                                            id="order_status_option9"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 9, 11)"
                                        >
                                            <p id="order_status_option9_text" class="option_text">Перенесен</p>
                                        </div>
                                        <div
                                            id="order_status_option10"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 10, 11)"
                                        >
                                            <p id="order_status_option10_text" class="option_text">Приостановлен</p>
                                        </div>
                                        <div
                                            id="order_status_option11"
                                            class="option"
                                            v-on:click="tools.selectOptionsChoose('order_status', 11, 11)"
                                        >
                                            <p id="order_status_option11_text" class="option_text">Просрочен</p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </span>
                        <div class="d-flex" id="non_processed_block" style="width: 100%; color: #747474">
                            <div class="flex-item item_6" style="padding-left: 10px; flex-grow: 6">
                                <div
                                    style="
                                        flex-direction: row;
                                        display: flex;
                                        text-align: left;
                                        font-weight: 400;
                                        font-size: 12px;
                                        line-height: 16px;
                                        padding: 15px;
                                    "
                                >
                                    <div style="width: 10%">No / Время</div>
                                    <div style="width: 15%">Когда</div>
                                    <div style="width: 25%" id="whereFromToDiv">Откуда/Куда</div>
                                    <div style="width: 20%">Пациент/Транспорт</div>
                                    <div style="width: 10%; text-align: center">Кол-во пассажиров</div>
                                </div>
                                <div v-if="!has_loaded_once" class="loading_text">
                                    Данные загружаются, пожалуйста, подождите
                                </div>
                                <div v-else>
                                    <div
                                        v-for="order in orders"
                                        :key="'non_processed_orders_element' + order.id"
                                        :id="'non_processed_orders_element' + order.id"
                                    >
                                        <span class="superviser__history_item">
                                            <div class="container__history">
                                                <div class="container__itemID">
                                                    <div style="padding-bottom: 6px" class="itemID">{{ order.id }}</div>
                                                    <div class="itemID__time">{{ order.time }}</div>
                                                </div>
                                                <div class="container__date">
                                                    <div style="padding-bottom: 6px" class="date__item">
                                                        {{ order.datetime_from }}
                                                    </div>
                                                    <div class="date__item">{{ order.datetime_to }}</div>
                                                </div>
                                                <div class="container__place" style="width: 25%">
                                                    <div style="padding-bottom: 6px" class="place__adress">
                                                        <img
                                                            alt="arrow"
                                                            class="img_history"
                                                            src="../assets/IMGS/SVG/arrow_green_r.svg"
                                                        /><span class="place__text">{{ order.place_from }}</span>
                                                    </div>
                                                    <div class="place__adress">
                                                        <img
                                                            alt="arrow"
                                                            class="img_history"
                                                            src="../assets/IMGS/SVG/arrow_green_r.svg"
                                                        /><span class="place__text">{{ order.place_to }}</span>
                                                    </div>
                                                </div>
                                                <div class="container__patientHistory" style="width: 20%">
                                                    <div style="padding-bottom: 6px" class="patient__item">
                                                        <img style="display: none" class="green-img" src="" />{{
                                                            order.patient_info
                                                        }}
                                                    </div>
                                                    <div class="patient__item">
                                                        <img
                                                            class="green-img"
                                                            src="../assets/IMGS/SVG/car.svg"
                                                            alt="car"
                                                        />{{ order.transport }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="container__Hsummary"
                                                    style="width: 10%; align-items: center"
                                                >
                                                    {{ order.passengers }}
                                                </div>
                                                <div class="container__buttonsMenu" style="width: 20%">
                                                    <div
                                                        style="width: 45px; height: 45px"
                                                        class="container__patientHistory"
                                                    >
                                                        <img
                                                            style="margin-left: 12px"
                                                            src="../assets/IMGS/SVG/printer.svg"
                                                            alt="printer"
                                                        />
                                                    </div>
                                                    <button
                                                        class="btn-reset btn btn_blue blocked"
                                                        type="submit"
                                                        value="confirm"
                                                        :id="'button_confirm_' + order.id"
                                                        v-on:click="dispatcherConfirmOrder(order.id)"
                                                    >
                                                        {{ translateStatusIntoShorter(order.status) }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="underline__history"></div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="applications_page"  class="account_page">
                    <div class="d-flex">
                        <div class="flex-item item_2_space"></div>
                        <span class="flex-item item_8">
                            <span class="flex-item section">Заявки на перевозчика</span>
                            <div style="height: 40px" class="flex-item item_2_space"></div>
                            <div
                                v-for="partner in applications"
                                :key="'partner' + partner.id"
                                style="
                                    padding: 10px;
                                    background: rgba(0, 0, 0, 0.025);
                                    align-items: center;
                                    justify-content: space-between;
                                    display: flex;
                                "
                                class="container__history"
                            >
                                <div style="width: 200px" class="container__itemID">
                                    <div style="padding-bottom: 6px" class="itemID">Id: {{ partner.id }}</div>
                                </div>
                                <div class="container__patientHistory">
                                    <div style="padding-bottom: 6px" class="patient__item">
                                        <img style="" class="green-img" src="" />ИНН {{ partner.inn }}
                                    </div>
                                    <div style="padding-bottom: 6px" class="patient__item">
                                        <img style="" class="green-img" src="" />{{ partner.organisation_name }}
                                    </div>
                                </div>
                                <div class="container__patientHistory">
                                    <div style="padding-bottom: 6px" class="patient__item">
                                        <img style="" class="green-img" src="" />{{ partner.name }}
                                        {{ partner.patronymic }}
                                    </div>
                                </div>
                                <div class="container__patientHistory">
                                    <div style="padding-bottom: 6px" class="patient__item">
                                        <img
                                            style=""
                                            class="green-img"
                                            src="../assets/IMGS/SVG/phone.svg"
                                            alt="phone"
                                        />{{ partner.phone }}
                                    </div>
                                    <div style="padding-bottom: 6px" class="patient__item">
                                        <img
                                            style="margin-right: 12px"
                                            class=""
                                            src="../assets/IMGS/SVG/info.svg"
                                            alt="info"
                                        />{{ partner.email }}
                                    </div>
                                </div>
                                <div class="container__buttonsMenu">
                                    <div style="width: 45px; height: 45px" class="container__patientHistory">
                                        <img
                                            style="margin-left: 12px"
                                            src="../assets/IMGS/SVG/printer.svg"
                                            alt="printer"
                                        />
                                    </div>
                                    <button
                                        style="background: #fa777e"
                                        class="ui-button ui-button--sm ui-button--grey"
                                        type="submit"
                                        value="cancel"
                                        :id="'button_cancel_' + partner.id"
                                        v-on:click="adminCancelApplication(partner.id)"
                                    >
                                        Отменить
                                    </button>
                                    <button
                                        class="ui-button ui-button--sm ui-button--secondary"
                                        type="submit"
                                        value="confirm"
                                        :id="'button_confirm_' + partner.id"
                                        v-on:click="adminConfirmApplication(partner.id)"
                                    >
                                        Подтвердить
                                    </button>
                                </div>
                            </div>
                            <div style="height: 40px" class="flex-item item_2_space"></div>
                        </span>
                        <div class="flex-item item_2_space"></div>
                    </div>
                </div>

                <div id="settings_page" class="account_page row g-4">
                    <div v-if="organisation">
                        <p
                            class="marginPaddingForm"
                            style="text-align: left; color: rgb(110, 118, 117); font-size: 20px"
                        >
                            <b class="formlabel">Перевозчик: </b> {{ organisation }}
                        </p>
                        <br />
                    </div>
                    <div class="">
                        <div class="row g-4">
                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="name"
                                    type="text"
                                    ref="firstname"
                                    id="firstname"
                                    name="firstname"
                                    label="Имя"
                                    required
                                    :isDisabled="isUserDataDisabled"
                                />
                            </div>

                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="secondname"
                                    type="text"
                                    ref="secondname"
                                    id="secondname"
                                    name="secondname"
                                    label="Отчество"
                                    :isDisabled="isUserDataDisabled"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row g-4">
                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="email"
                                    type="text"
                                    :validationFunction="tools.validateEmail"
                                    ref="email"
                                    id="email"
                                    name="email"
                                    label="E-mail"
                                    required
                                    :isDisabled="isUserDataDisabled"
                                />
                            </div>

                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="phone"
                                    type="text"
                                    :validationFunction="tools.validatePhone"
                                    :mask="tools.formatPhone"
                                    ref="phone"
                                    id="phone"
                                    name="phone"
                                    label="Телефон"
                                    placeholder="+7 (___) ___-__-__"
                                    required
                                    :isDisabled="isUserDataDisabled"
                                />
                            </div>
                        </div>
                        <div>
                            <p id="reg_res" class="account-page__error"></p>
                        </div>
                    </div>

                    <div class="">
                        <div
                            id="change_data"
                            class="ui-button ui-button--xl ui-button--secondary"
                            :class="{
                                blocked: role_value == 'Dispatcher',
                                button_not_active: role_value == 'Dispatcher',
                            }"
                            @click="handleUserDataChange"
                        >
                            {{`${isUserDataDisabled ? 'Изменить' : 'Сохранить'} мои данные`}}
                        </div>
                    </div>

                    <div>
                        <div class="row g-4">
                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="password"
                                    type="password"
                                    ref="password"
                                    id="password"
                                    name="password"
                                    label="Пароль"
                                    placeholder="*********"
                                    required
                                    :isDisabled="isUserPasswordDisabled"
                                />
                            </div>

                            <div class="col-12 col-md-6">
                                <CInput
                                    v-model="passwordRepeat"
                                    type="password"
                                    ref="password_repeated"
                                    id="password_repeated"
                                    name="password_repeated"
                                    label="Пароль (повторно)"
                                    placeholder="*********"
                                    required
                                    :isDisabled="isUserPasswordDisabled"
                                />
                            </div>
                        </div>
                        <div>
                            <p id="change_password_res" class="account-page__error"></p>
                        </div>
                    </div>

                    <div class="">
                        <div
                            id="change_password"
                            class="ui-button ui-button--xl ui-button--secondary"
                            :class="{
                                blocked: role_value == 'Dispatcher',
                                button_not_active: role_value == 'Dispatcher',
                            }"
                            @click="handleUserPasswordChange"
                        >
                        {{`${isUserPasswordDisabled ? 'Изменить' : 'Сохранить'} пароль`}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var phone_check = '';
// var password_ids = '';
// var password_toggles = '';
var all_things = '';

import $ from 'jquery';
import { useCookies } from 'vue3-cookies';
import tools from '@/assets/js/tools.js';
import { mask } from 'vue-the-mask';
import eRegionMenu from './eRegionComponent.vue';
import CInput from './InputComponent.vue';

export default {
    name: 'AccountPage',
    el: '#all_page',
    directives: { mask },
    components: {
        CInput,
        regionMenu: eRegionMenu,
    },
    data() {
        var my_role = this.getCookie('role');
        return {
            SearchInputTable: {
                SearchTypeName: 'Поиск по заказам', // Header типа который сейчас выбран
                searchQuery: '', // То что пишет человек в инпут (под вопросом)
                SearchInputType: 'search_orders', // Выбранный сейчас тип (буду отправлять на бек)
                selectedFilter: 'id', // Выбранный фильтр (под вопросом)
                filters: {
                    // Варианты фильтров который соотвтсвуют выбранному типу (для масштабирования)
                    search_orders: {
                        id: 'По ID',
                        contactName: 'По имени',
                        contactPhone: 'По номеру телефона',
                        email: 'По электронной почте',
                    },
                    search_users: {
                        id: 'По ID',
                        name: 'По имени',
                        phone: 'По номеру телефона',
                        email: 'По электронной почте',
                    },
                    search_carriers: {
                        id: 'По ID',
                        name: 'По имени',
                        inn: 'По ИНН',
                    },
                },
                data: [], // Дата которая приходит с Ajax (пока JSON)
            },
            orders: [],
            applications: [],
            role_value: my_role,
            is_owner: my_role == 'Owner',
            is_admin: my_role == 'Administrator',
            translateStatusIntoShorter: tools.translateStatusIntoShorter,
            has_loaded_once: false,
            dispatcherPhone: '',
            dispatcherEmail: '',
            default_region: '',
            setToDefault: tools.setToDefault,
            tools: tools,
            visibleFilters: true,
            email: null,
            name: null,
            secondname: null,
            phone: null,
            password: null,
            passwordRepeat: null,
            isUserDataDisabled: true,
            isUserPasswordDisabled: true
        };
    },
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    computed: {
        filteredData() {
            // Фильтр для поиска
            const selectedFilter = this.SearchInputTable.selectedFilter;
            const searchQuery = this.SearchInputTable.searchQuery.toLowerCase();

            return this.SearchInputTable.data.filter((item) => {
                if (selectedFilter) {
                    const valueToSearch = String(item[selectedFilter]).toLowerCase(); // Преобразование к строке
                    return valueToSearch.includes(searchQuery);
                }
                return item.name.toLowerCase().includes(searchQuery);
            });
        },
    },
    watch: {
        'SearchInputTable.SearchTypeName': function (newTypeName) {
            // Следим и при изменениях ставим тип *обновляя вариантов фильтрации
            if (newTypeName === 'Заказы') {
                this.SearchInputTable.SearchInputType = 'search_orders';
            } else if (newTypeName === 'Пользователи') {
                this.SearchInputTable.SearchInputType = 'search_users';
            } else if (newTypeName === 'Перевозчики') {
                this.SearchInputTable.SearchInputType = 'search_carriers';
            }
        },
    },
    mounted() {
        tools.addAutocompletion('organisation_name', 'organisation_names');
        var vm = this;

        vm.getSearchResponse('orders'); // запрос на парсинг json

        // function foolproofString(s) {
        //     if (s.trim() == '') {
        //         return false;
        //     }
        //     return true;
        // }

        function foolproofEmail(email) {
            email = email.toLowerCase();
            const re =
                /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            return re.test(email);
        }

        function foolproofPhone(phone) {
            phone_check = phone.replace(/[^0-9]/g, '');
            if (phone_check.length == 11) {
                return true;
            }
            return false;
        }

        // password_ids = ['password_settings', 'password_repeat_settings'];
        // password_toggles = ['toggle_password_settings', 'toggle_password_repeat_settings'];

        // for (let i = 0; i < password_ids.length; ++i) {
        //     const togglePassword = document.querySelector('#' + password_toggles[i]);
        //     const password = document.querySelector('#' + password_ids[i]);
        //     togglePassword.addEventListener('click', function () {
        //         // toggle the type attribute
        //         const type = password.getAttribute('type') === 'password' ? '' : 'password';
        //         password.setAttribute('type', type);
        //         // toggle the eye slash icon
        //         this.classList.toggle('fa-eye-slash');
        //     });
        // }

        $('#form_new_dispatcher').submit(function (e) {
            e.preventDefault();
        });
        const set_dispatcher = document.getElementById('set_dispatcher');
        set_dispatcher.addEventListener('click', function () {
            if (foolproofEmail(vm.dispatcherEmail) && foolproofPhone(vm.dispatcherPhone)) {
                var dispatcher = {
                    email: vm.dispatcherEmail,
                    phone: vm.dispatcherPhone,
                };
                var formData = JSON.stringify(dispatcher);
                $.ajax({
                    type: 'POST',
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + '/account/new_dispatcher',
                    data: formData,
                    success: function () {
                        document.getElementById('add_dispatcher').innerHTML = 'Права диспетчера были успешно выданы!';
                        document.getElementById('add_dispatcher').style.color = 'green';
                    },
                    error: function () {
                        document.getElementById('add_dispatcher').innerHTML = 'Email или телефон введены неправильно!';
                        document.getElementById('add_dispatcher').style.color = 'red';
                    },
                    dataType: 'text',
                    contentType: 'application/json',
                }).done(function () {});
            }
        });

        const remove_dispatcher = document.getElementById('remove_dispatcher');
        remove_dispatcher.addEventListener('click', function () {
            if (foolproofEmail(vm.dispatcherEmail) && foolproofPhone(vm.dispatcherPhone)) {
                var dispatcher = {
                    email: vm.dispatcherEmail,
                    phone: vm.dispatcherPhone,
                };
                var formData = JSON.stringify(dispatcher);
                $.ajax({
                    type: 'POST',
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + '/account/delete_dispatcher',
                    data: formData,
                    success: function () {
                        document.getElementById('add_dispatcher').innerHTML = 'Права диспетчера были успешно отозваны!';
                        document.getElementById('add_dispatcher').style.color = 'green';
                    },
                    error: function () {
                        document.getElementById('add_dispatcher').innerHTML = 'Email или телефон введены неправильно!';
                        document.getElementById('add_dispatcher').style.color = 'red';
                    },
                    dataType: 'text',
                    contentType: 'application/json',
                }).done(function () {});
            }
        });

        // document.getElementById('firstname').disabled = true;
        // document.getElementById('secondname').disabled = true;
        // document.getElementById('email_settings').disabled = true;
        // document.getElementById('phone_settings').disabled = true;
        // document.getElementById('password_settings').disabled = true;
        // document.getElementById('password_repeat_settings').disabled = true;

        // document.getElementById('change_data').style.background = '';
        // document.getElementById('change_password').style.background = '';
        // document.getElementById('firstname').disabled = true;
        // document.getElementById('secondname').disabled = true;
        // document.getElementById('email_settings').disabled = true;
        // document.getElementById('phone_settings').disabled = true;
        // document.getElementById('password_settings').disabled = true;
        // document.getElementById('password_repeat_settings').disabled = true;

        function fancyShowText(target, message, index, interval) {
            if (index < message.length) {
                $(target).append(message[index++]);
                setTimeout(function () {
                    fancyShowText(target, message, index, interval);
                }, interval);
            }
        }
        fancyShowText(
            $('#console_terminal'),
            'Version: 11022023\nИспользуйте команды PostrgreSql для управления базой данной. Примеры:\n' +
                "- загрузить новый адрес в базу данных: INSERT INTO eregionentity (id, enumm) VALUES (1234, 'новый адрес');\n" +
                '- дать пользователю роль администратора: UPDATE UserEntity SET isAdmin = true WHERE id = id_пользователя;\n\n',
            0,
            5
        );
        function terminalAddResponse(text) {
            $('#console_terminal').removeAttr('disabled');
            $('#console_terminal').val($('#console_terminal').val() + text);
            $('#console_terminal').blur();
            $('#console_terminal').focus();
        }
        $('#console_terminal').keydown(function (ev) {
            if (ev.which == 38 || ev.which == 40) return false;
            if (ev.which == 13) {
                var last_command = '\n' + $('#console_terminal').val();
                last_command = last_command.substr(last_command.lastIndexOf('\n') + 1);
                $.ajax({
                    type: 'GET',
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + `/api/sql_as_admin?sql=${last_command}`,
                    success: function (data) {
                        terminalAddResponse('< ' + data + '\n');
                    },
                    error: function () {
                        terminalAddResponse('< ERROR\n');
                    },
                    dataType: 'text',
                    contentType: 'application/json',
                });
                terminalAddResponse('\n');
                $('#console_terminal').attr('disabled', 'disabled');
                return false;
            }
        });
        $('#console_terminal').keyup(function () {
            return false;
        });
        $.ajax({
            type: 'GET',
            xhrFields: { withCredentials: true },
            url: global.BACKEND_URL + `/account`,
            success: function (data) {
                vm.name = data['name'];
                vm.secondname = data['patronymic'];
                vm.phone = data['phone'];
                vm.email = data['email'];
                vm.default_region = data['region'];
                vm.organisation = data['organisation'];
            },
            error: function () {
                console.log('Not success :(');
            },
            dataType: 'json',
            contentType: 'application/json',
        });

        this.hide_all_pages();
        const url_params = new URLSearchParams(window.location.search);
        const redirect_to = url_params.get('redirect');
        if (redirect_to == 'settings') {
            this.slider_click('settings', all_things - 1, all_things);
        } else if (this.role_value == 'Administrator') {
            this.slider_click('searchData', 0, all_things);
        } else {
            this.slider_click('my_medmobil', 0, all_things);
        }
        this.reRender();
        setInterval(() => {
            this.reRender();
        }, 5000);
        //end
    },
    methods: {
        handleUserDataChange() {
            if (this.isUserDataDisabled) {
                this.isUserDataDisabled = false;
                return;
            } 

            if (!this.name || !this.email || !this.phone) {
                document.getElementById('reg_res').innerHTML = 'Не заполнены обязательные поля.';
                return;
            }

            document.getElementById('reg_res').innerHTML = '';

            const auth = {
                firstname: this.name,
                secondname: this.secondname,
                email: this.email,
                phone: this.phone,
            };
            const formData = JSON.stringify(auth);

            $.ajax({
                type: 'POST',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + '/account/change_data',
                data: formData,
                success: function () {},
                error: function () {
                    document.getElementById('reg_res').innerHTML = 'Возникла ошибка.';
                },
                dataType: 'text',
                contentType: 'application/json',
            }).done(function () {
                const sessionStorage = window.sessionStorage;
                sessionStorage.setItem('name&patronymic', 'null');
                document.location = '/account?redirect=settings';
            });
        },

        handleUserPasswordChange() {
            if (this.isUserPasswordDisabled) {
                this.isUserPasswordDisabled = false;
                return;
            }

            if (!this.password || !this.passwordRepeat) {
                document.getElementById('change_password_res').innerHTML = 'Не заполнены обязательные поля.';
                return;
            }

            if (this.password !== this.passwordRepeat) {
                document.getElementById('change_password_res').innerHTML = 'Пароли не совпадают.';
                return;
            }

            document.getElementById('change_password_res').innerHTML = '';

            const reg = {
                password: this.password,
            };
            const formData = JSON.stringify(reg);
            $.ajax({
                type: 'POST',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + '/account/change_password',
                data: formData,
                success: function () {},
                error: function () {
                    document.getElementById('change_password_res').innerHTML = 'Возникла ошибка.';
                },
                dataType: 'text',
                contentType: 'application/json',
            }).done(function () {
                document.location = '/account?redirect=settings';
            });
        },

        getSearchResponse(searchtype) {
            //Временный парсинг JSON файла
            var vm = this;
            vm.SearchInputTable.SearchInputType = 'search_' + searchtype;
            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/get_operator_data?type=${searchtype}`,
                success: function (parsedJSONdata) {
                    vm.SearchInputTable.data = parsedJSONdata;
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'json',
                contentType: 'application/json',
            });
        },
        flexFilters() {
            if (this.visibleFilters === true) {
                $('#filter_status').css('display', 'none');
                $('#filter_org').css('display', 'none');
                $('#superviser__control').css('width', '50px');
                $('#superviser__control').css('min-width', '50px');
                $('#filter__head').css('width', '28px');
                $('#filter_zone_item').css('opacity', '0');
                $('#filter_zone_item').css('display', 'none');
                this.visibleFilters = false;
            } else if (this.visibleFilters === false) {
                $('#filter_status').css('display', 'flex');
                $('#filter_org').css('display', 'flex');
                $('#superviser__control').css('width', '256px');
                $('#superviser__control').css('min-width', '256px');
                $('#filter__head').css('width', '234px');
                $('#filter_zone_item').css('opacity', '1');
                $('#filter_zone_item').css('display', 'flex');
                this.visibleFilters = true;
            }
        },
        reFiltering() {
            this.setToDefault();
            this.reRender();
        },
        saveRegionCarrier() {
            var new_region = $('#region_owner .lmenu_text:first').text();
            console.log(new_region);
            $.ajax({
                type: 'POST',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + '/add_region_to_owner?region=' + new_region,
                success: function () {
                    console.log('ok');
                },
                error: function () {
                    console.log('not ok');
                },
                dataType: 'text',
                contentType: 'application/json',
            });
        },
        hideFilterStatus() {
            $('#filter_status_details').removeAttr("open");
        },
        hide_all_pages: function() {
            $(".account_page").map(function() {
                $("#" + this.id).css("display", "none");
            })
        },
        slider_click: function(el_id) {
            this.hide_all_pages();
            $("#st_l").css("width", $("#" + el_id).outerWidth());
            $("#st_l").css("margin-left", $("#" + el_id).position().left-$("#st_p").position().left);
            $("#" + el_id + "_page").css("display", "block");
        },
        getCookie(val) {
            return this.cookies.get(val);
        },
        adminCancelApplication(partner_id) {
            var vm = this;
            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/reject_app?owner_id=${partner_id}`,
                success: function () {
                    vm.reRender();
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'text',
                contentType: 'application/json',
            });
        },
        adminConfirmApplication(partner_id) {
            var vm = this;
            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/permit_app?owner_id=${partner_id}`,
                success: function () {
                    vm.reRender();
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'text',
                contentType: 'application/json',
            });
        },
        reRender() {
            var vm = this;
            var status_dict = {
                Любой: -1,
                Создан: 0,
                Подтвержден: 1,
                Запланирован: 2,
                Выезд: 3,
                Выполняется: 4,
                Выполнен: 5,
                Отмена: 8,
                Отказ: 9,
                Перенесен: 10,
                Приостановлен: 11,
                Просрочен: 12,
            };
            var status_filter = status_dict[document.getElementById('order_status').innerText];
            if (this.role_value != 'Administrator') return;
            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/get_unprocessed_apps_owner`,
                success: function (data) {
                    var current_applications = [];
                    data.forEach((singular_application) => {
                        current_applications = current_applications.concat([
                            {
                                id: singular_application['id'],
                                inn: singular_application['inn'],
                                organisation_name: singular_application['name'],
                                secondname: singular_application['user_patronymic'],
                                name: singular_application['user_name'],
                                phone: singular_application['user_phone'],
                                email: singular_application['user_email'],
                            },
                        ]);
                    });
                    vm.applications = current_applications;
                    $('#superviserRequests').text(vm.applications.length);
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'json',
                contentType: 'application/json',
            });

            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url:
                    global.BACKEND_URL +
                    `/admin/carrier_orders?carrier_name=${$('#organisation_name').val()}&status=${status_filter}`,
                success: function (data) {
                    vm.has_loaded_once = true;
                    var current_orders = [];
                    data.forEach((singular_order) => {
                        current_orders = current_orders.concat([
                            {
                                id: singular_order['idOrder'],
                                time: singular_order['orderDate'],
                                datetime_from: singular_order['orderDateStart'],
                                datetime_to: singular_order['orderDateBack'],
                                place_from: singular_order['addressStart'],
                                place_to: singular_order['addressFinish'],
                                passengers: singular_order['numPassenger'],
                                patient_info: singular_order['escort'],
                                transport: singular_order['transport'],
                                is_return: singular_order['isReturn'],
                                status: singular_order['status'],
                            },
                        ]);
                    });
                    vm.orders = current_orders;
                    $('#inWorkRequests').text(vm.orders.length);
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'json',
                contentType: 'application/json',
            });
        },
    },
};
</script>

<!--<style scoped src="@/assets/css/form.css"></style>-->
<style scoped src="@/assets/css/account.css"></style>
<style scoped src="@/assets/css/dispatcher_orders.css"></style>

<style lang="scss">
.account-page {
    &__error {
        color: #ee6870;
        font-size: 16px;
        line-height: 18px;
    }
}
</style>
